import { database } from './db';

/** Open sales kept on this computer, one record per business, so a reload or crash does not lose them. */
const POS_OPEN_SALES_STORE = 'pos-open-sales';

export async function savePosOpenSales<TState extends object>(
	key: string,
	state: TState,
): Promise<void> {
	await database.put({ key, storeName: POS_OPEN_SALES_STORE, data: state });
}

export async function getPosOpenSales<TState>(
	key: string,
): Promise<TState | null> {
	return database.get<TState>({ key, storeName: POS_OPEN_SALES_STORE });
}
